/**
 * @generated SignedSource<<56da5fef77a4dcf791acb8e33192a81b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionListItemAssignedEmployees_RoutineOccasion$data = {
  readonly assigned: ReadonlyArray<{
    readonly assignedAt: string | null;
    readonly employee: {
      readonly id: string;
      readonly isLinkedToViewer: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"ListItemAssignees_employees">;
    } | null;
    readonly id: string;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly " $fragmentSpreads": FragmentRefs<"ListItemAssignees_roles">;
    };
  }>;
  readonly " $fragmentType": "RoutineOccasionListItemAssignedEmployees_RoutineOccasion";
};
export type RoutineOccasionListItemAssignedEmployees_RoutineOccasion$key = {
  readonly " $data"?: RoutineOccasionListItemAssignedEmployees_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionListItemAssignedEmployees_RoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionListItemAssignedEmployees_RoutineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkedToViewer",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ListItemAssignees_employees"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ListItemAssignees_roles"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "76ba78b9e6a7897ceb677cf06713c03c";

export default node;
